import axios from "../../../../utils/request"
function GET_LIST(params) {

    return axios.get("/statistics/TemplateUsedLog/templateCustomerList",{
    // return axios.get("/statistics/TemplateUsedLog/templateLog",{
        params:{...params}
    } )
}
export default {
    GET_LIST,
}
